import { createSlice } from '@reduxjs/toolkit'
import AuthApi from "api/Auth/auth";
import {encryptionjs,decryptionjs,testEncryptFixed,testDecrypt} from "utility/crypto";
// Slice

const initialUser = {MG_TOKEN:"",HC_TOKEN:"",USER_DETAILS_MG:"",USER_DETAILS_HC:"",USERCHECK:"",OTPDETAILS:"",HCID:"",MGID:"",ISLOADING:false}

const slice = createSlice({
  name: 'Auth',
  initialState: {
    user: initialUser,
  },
  reducers: {
     MgTokenSuccess: (state, action) => {
        state.user.MG_TOKEN = action.payload;
     
      },
    HcTokenSuccess: (state, action) => {
        state.user.HC_TOKEN = action.payload;
   
      },
      registerSuccess:(state,action)=>{
        state.user.USER_DETAILS_MG = action.payload;
      },
    signupCheck: (state, action) => {
       state.user.USERCHECK = action.payload;
      //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
      
    loginSuccess: (state, action) => {
      state.user.USER_DETAILS_MG = action.payload;
      state.user.MGID=action.payload.ApplicantId
    //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
    setHCID: (state, action) => {
      state.user.HCID=action.payload
    //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
    loginSuccessHC: (state, action) => {
      state.user.USER_DETAILS_HC = action.payload;
    //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
    logoutSuccess: (state, action) =>  {
      // state.user = null;
      // state.dashboard = null;
      // state.docuement = null;
      sessionStorage.removeItem('token');
      // this.props.history.replace("/login")
      localStorage.clear();
      window.location.href = '/';
    },
    setLOADER: (state, action) => {
      state.user.ISLOADING=action.payload
    //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
    reset: state => initialUser
  },
});

export default slice.reducer

// Actions

const { MgTokenSuccess,HcTokenSuccess,loginSuccess, logoutSuccess,reset,signupCheck,registerSuccess,loginSuccessHC,setHCID,setLOADER } = slice.actions

export const setLoader = (user) => async dispatch => {
  try {
 
    dispatch(setLOADER(user));
  } catch (e) {
    return console.error(e.message);
  }
}
export const checkSignup = (user) => async dispatch => {
  try {
    let response= await AuthApi.Magittsignup(user)
    dispatch(signupCheck(response));
  } catch (e) {
    return console.error(e.message);
  }
}

export const setMgToken = (user) => async dispatch => {
    try {
      dispatch(MgTokenSuccess(user));
    } catch (e) {
      return console.error(e.message);
    }
  }
  export const setHcToken = (user) => async dispatch => {
    try {
    
      dispatch(HcTokenSuccess(user));
    } catch (e) {
      return console.error(e.message);
    }
  }
export const login = (user) => async dispatch => {
  try {
    
    let ss = btoa(await encryptionjs(JSON.stringify(user)));
    
  //  let decode=await decryptionjs(ss);
    
    var data = {
      UserData: ss
  }
  
    let response = await AuthApi.Magittlogin(data);

    var ssRES = await atob(response);
   
    var result = await decryptionjs(ssRES);

     await dispatch(loginSuccess(result));
    return await returnCode(result);
  } catch (e) {
    return console.error(e.message);
  }
}
export const loginHC = (user) => async dispatch => {
  try {
  
    let ss = { "Data":  testEncryptFixed(JSON.stringify(user)).toString() }
   // ss={Data: "+7rXNLXJBBHeRWbkBQKuCUSJGXy4qL9fXgqSQ7Jr+KkG5QwdhKjq0HNveyR/W0mU"}
    let response = await AuthApi.Hclogin(ss);
    
    response = testDecrypt(response.Data);

    await dispatch(loginSuccessHC(response));
    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
}
export const createNewUser = (user) => async dispatch => {
  try {
    let response= await AuthApi.MagittcreateNewUser(user);
    // await dispatch(loginSuccess(user));
    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
}
export const registration = (user) => async dispatch => {
  try {
    let response= await AuthApi.Magittregistration(user);
     await dispatch(loginSuccess(response));
    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
}
export const setHCIDAction = (user) => async dispatch => {
  try {
  
    await dispatch(setHCID(user));
   
  } catch (e) {
    return console.error(e.message);
  }
}
export const SaveCandidateId = (user) => async dispatch => {
  try {
  
   let response=await AuthApi.SaveCandidateId(user);
   return await returnCode(response);
   
  } catch (e) {
    return console.error(e.message);
  }
}

export const logout = () => async dispatch => {
  try {
    // await api.post('/api/auth/logout/')
    await dispatch(reset())
    return dispatch(logoutSuccess())
  } catch (e) {
    return console.error(e.message);
  }
}



export const SaveWhatsapp = (user) => async dispatch => {
  try {
  
   let response=await AuthApi.Whatsapp(user);
   return await returnCode(response);
   
  } catch (e) {
    return console.error(e.message);
  }
}

function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
